import UpdateFirmwareContainer from "./UpdateFirmwareContainer";

export default UpdateFirmwareContainer;
